import styled from 'styled-components';
import RewardBonusHeadSvg from '../../assets/header/reward_bonus.svg';

const RewardBonusHeadIcon = styled(RewardBonusHeadSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
    width: ${props => props.width || '1.8rem'};
    height: ${props => props.height || '2rem'};
`;

export default RewardBonusHeadIcon;
